var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1086,
    height: 959,
    viewBox: "0 0 1086 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2105_36048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1086,
    height: 959
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1086,
    height: 959,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2105_36048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.024 339.125C277.323 337.425 275.292 336.082 273.059 335.159C270.834 334.245 268.444 333.77 266.027 333.77C263.609 333.77 261.219 334.245 258.995 335.159C256.761 336.082 254.739 337.425 253.03 339.125L147.112 455.21C140.825 461.945 137.332 470.792 137.332 479.977C137.332 489.161 140.825 498.008 147.112 504.744V504.808L253.03 620.874C255.603 623.433 258.885 625.17 262.451 625.873C266.018 626.577 269.713 626.211 273.077 624.822C276.432 623.433 279.3 621.084 281.322 618.078C283.335 615.071 284.41 611.534 284.41 607.915V352.002C284.401 347.177 282.462 342.543 279.024 339.125Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.224 754.617C432.233 756.999 432.721 759.363 433.677 761.545C434.633 763.735 436.021 765.707 437.767 767.341C439.514 768.975 441.582 770.234 443.834 771.047C446.086 771.859 448.486 772.197 450.876 772.051C604.637 762.421 726.381 635.371 726.381 479.998C726.381 324.624 604.628 197.519 450.876 187.944C448.486 187.789 446.086 188.136 443.834 188.939C441.573 189.752 439.505 191.011 437.758 192.645C436.011 194.279 434.623 196.25 433.667 198.441C432.72 200.632 432.224 202.996 432.224 205.378V314.958C432.261 319.878 434.118 324.615 437.436 328.257C440.755 331.908 445.296 334.217 450.214 334.738C485.816 339.137 518.568 356.325 542.321 383.069C566.075 409.814 579.183 444.271 579.183 479.961C579.183 515.642 566.075 550.099 542.321 576.843C518.568 603.588 485.816 620.776 450.214 625.175C445.305 625.705 440.755 628.014 437.436 631.656C434.118 635.307 432.27 640.035 432.224 644.955V754.617Z",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.371 961.374C431.387 965.55 432.241 969.694 433.916 973.518C435.59 977.358 438.022 980.814 441.081 983.678C444.141 986.542 447.764 988.75 451.709 990.174C455.655 991.598 459.858 992.19 464.044 991.934C733.4 975.054 946.668 752.35 946.668 479.999C946.668 207.647 733.383 -15.1527 464.044 -31.9367C459.858 -32.2087 455.655 -31.6005 451.709 -30.1925C447.748 -28.7685 444.125 -26.5604 441.065 -23.6964C438.006 -20.8324 435.574 -17.3768 433.899 -13.5368C432.241 -9.69678 431.371 -5.55263 431.371 -1.37664",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 8,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneLogo);
export default __webpack_public_path__ + "static/media/stoneLogo.bb47ce56df1c3754ec5c8dbc3da2d353.svg";
export { ForwardRef as ReactComponent };